(ns manage.content-configuration-page.view.import
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [cljs.pprint]
            [clojure.edn :as edn]
            [clojure.string :as str]
            [common.patterns.loading-view :refer [loading-view]]
            [common.url-template :as url-tpl]
            [common.widgets.details :refer [details]]
            [common.widgets.input :refer [input]]
            [common.widgets.panel :refer [panel]]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def reason->description
  {"redirected-to-sign-in-page-fetching"
   "Reading data sheet failed due not being authenticated (redirected to sign in page)."})

(defui content-function-export-import []
  (let [content-function-in-FE (use-subscribe [:resource.content-function/one])
        [payload set-payload] (uix/use-state nil)]
    ($ Stack
       {:spacing 1
        :sx #js {:height "100%"}}
       ($ input
          {:onChange #(set-payload (.. % -target -value))
           :value payload
           :multiline true
           :sx #js {:flex 1
                    ".MuiInputBase-input" #js {:height "100%!important"}}})
       ($ Stack {:direction "row" :spacing 1}
          ($ Button
             {:variant "contained"
              :onClick (fn []
                         (when-some [value (:value content-function-in-FE)]
                           (set-payload (-> value
                                            clj->js
                                            js/JSON.stringify))))}
             "Export JSON")
          ($ Button
             {:variant "contained"
              :disabled (str/blank? payload)
              :onClick (fn []
                         (rf/dispatch [:resource.content-function/get-one-success nil
                                       (js->clj (js/JSON.parse payload)
                                                :keywordize-keys true)]))}
             "Import JSON")
          ($ Button
             {:sx #js {:alignSelf "right"}
              :variant "contained"
              :onClick (fn []
                         (rf/dispatch [:page.content-variant/export]))}
             "(Careful!) Save front-end data to the Server")
          ;; We let some end users access this panel, so I am hiding this button for now.
          #_ ($ Button
                {:variant "contained"
                 :onClick (fn []
                            (rf/dispatch [:resource.content-function/get-one-success nil
                                          (edn/read-string payload)]))}
                "Import EDN")))))

(defui import-failure []
  (let [error (use-subscribe [:page.content-configuration/import-status :failure])
        error-response (use-subscribe [:page.content-configuration/get-fields-failure-response])
        reason-description (reason->description (get-in error-response [:value :error :details :reason]))
        payload (use-subscribe [:resource.content-function/value])
        payload-str (when payload (with-out-str (cljs.pprint/pprint payload)))
        additional-info (or payload-str reason-description)
        error (some-> error .-message)
        url-context (use-subscribe [:url-context])]
    ($ panel
       {:data-component :import-failure
        :title "Could not load content configuration"}
       ($ Stack {:spacing 2.5}
          ($ :p "While loading your content configuration an error occurred.")
          ($ :p "Please reach out to our "
             ($ Link
                {:rel "noopener noreferrer"
                 :color "primary"
                 :target "_blank"
                 :href (url-tpl/render :docs/support url-context)}
                "support desk") ".")
          (r/as-element
           [details "Click here for more information"
            ($ Typography {:variant "h4"} (or error "Reading data sheet failed"))
            ($ Typography
               {:component "pre"
                :fontSize "caption.fontSize"
                :fontFamily "monospace"
                :tab-index -1
                :sx #js {:userSelect "all"
                         :maxHeight "24rem"
                         :overflowY "auto"}}
               additional-info)])
          ($ :p "You are able to continue but you will lose all your data!")
          ($ Button
             {:variant "contained"
              :color "error"
              :onClick #(rf/dispatch [:page.content-configuration/import-status :success])}
             "Continue anyway")))))

(defui import-pending []
  ($ loading-view {:data-component :import-pending}
     (when-let [status (use-subscribe [:page.content-configuration/import-status])]
       ($ :p (str/capitalize (name status)) " content configuration..."))))
